<template>
    <div class="ShareCertificate">
        <index 
            :payload-for-index="payloadForIndex"
            @view="view"
            @splitCertificate="splitCertificate"
        />

        <create-or-view-or-edit
            ref="createOrEdit"
            v-model="isShareCertificateSidebarActive"
            :data-sidebar-action-loading="isSideBarActionLoading"
            :data-status="status"
            :data-share-certificate="ShareCertificate"
            :data-next-certificate-number="nextCertificateNumber"
        />

        <split-certificate
            ref="splitCertificate"
            v-model="isSplitShareCertificateSidebarActive"
            :data-sidebar-action-loading="isSideBarActionLoading"
            :data-status="status"
            :data-share-certificate="ShareCertificate"
            :data-next-certificate-number="nextCertificateNumber"
            @update="updateSplitCertificate"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ref } from '@vue/composition-api';
import Index from './Index.vue';
import CreateOrViewOrEdit from './ViewOrEdit.vue';
import SplitCertificate from './SplitCertificate.vue';
import useShareCertificatesTable from './useShareCertificatesTable';
import { errorToast, successToast } from "@/views/helpers/toast";
import ShareCertificate from '@/models/ShareCertificiate';
import { REFRESH_AND_TRY_AGAIN_ERROR, SOMETHING_WENT_WRONG } from '@/constants/errors';
import { SHARE_CERTIFICATE_UPDATE_SUCCESS } from '@/constants/success';

export default {
    components: {
        Index,
        CreateOrViewOrEdit,
        SplitCertificate,
    },

    data() {
        return {
            status: undefined,
            ShareCertificate: {},
            isShareCertificateSidebarActive: false,
            isSplitShareCertificateSidebarActive: false,
            isSideBarActionLoading: false,
        };
    },

    computed: {
        ...mapGetters({
            user: "auth/user",
            isUserAdmin: "auth/isAdmin",
        }),
    },

    mounted()
    {
        // just to make sure the menu bar is shown
        this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
    },

    methods:{
        view(data) {
            this.ShareCertificate = data.item;
            this.status = "view";
            this.isShareCertificateSidebarActive = true;
        },

        splitCertificate(data) {
            this.ShareCertificate = data.item;
            this.status = 'edit';
            this.isSplitShareCertificateSidebarActive = true;
        },
    },

    setup() {
        const filterMode = ref(false);
        
        const {
            // table data
            sortBy,
            perPage,
            isBusy,
            dataMeta,
            currentPage,
            searchQuery,
            tableColumns,
            isSortDirDesc,
            perPageOptions,

            // UI
            resolveShareCertificateStatusVariant,
            isLoading,

            isPaidUpCapitalMatching,
            shareCertificates,
            refetchData,
            fetchShareCertificates,
            refShareCertificateListTable,
            totalShareCertificates,
            nextCertificateNumber
        } = useShareCertificatesTable();

        const payloadForIndex = {
            refetchData,
            sortBy,
            perPage,
            isBusy,
            dataMeta,
            currentPage,
            searchQuery,
            tableColumns,
            isSortDirDesc,
            isLoading,
            perPageOptions,
            isPaidUpCapitalMatching,
            shareCertificates,
            fetchShareCertificates,
            totalShareCertificates,
            refShareCertificateListTable,
            resolveShareCertificateStatusVariant,
        };

        function updateSplitCertificate(data) {
            if (this.isUserAdmin)
            {
                this.isSideBarActionLoading = true;

                if (! data.id)
                {
                    errorToast(REFRESH_AND_TRY_AGAIN_ERROR);
                    return;
                }

                ShareCertificate.split(data.id, data).then(() => {
                    this.isSplitShareCertificateSidebarActive = false;
                    this.isSideBarActionLoading = false;

                    fetchShareCertificates();
                    this.ShareCertificate = {};

                    successToast(SHARE_CERTIFICATE_UPDATE_SUCCESS);
                })
                    .catch(e => {
                        this.isSideBarActionLoading = false;
                        errorToast(SOMETHING_WENT_WRONG);

                        // eslint-disable-next-line no-console
                        console.error("error while trying to update certificate", e);
                    });
            }
        };

        return {
            refShareCertificateListTable,
            refetchData,
            fetchShareCertificates,

            // UI
            filterMode,

            // methods
            updateSplitCertificate,

            payloadForIndex,
            nextCertificateNumber
        };
    }
};
</script>